import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { log } from '@/lib/log';

/** Tiny live status pill. Polls /api/status every 30s. */
export const StatusIndicator = ({ compact = false }) => {
  const [ok, setOk] = useState(true);
  const [agents, setAgents] = useState(null);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const r = await api.get('/status');
        if (!alive) return;
        setOk(!!r.data.ok);
        setAgents(r.data.agents_online ?? null);
      } catch (err) {
        log.warn('status poll failed', err?.message || err);
        if (alive) setOk(false);
      }
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const color = ok ? '#39FF14' : '#ff5577';
  return (
    <div
      className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full hairline text-[10px] uppercase tracking-widest text-white/65"
      title={ok ? 'All systems operational' : 'Degraded'}
      data-testid="status-indicator"
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${ok ? 'pulse-green' : ''}`}
        style={{ background: color, boxShadow: `0 0 8px ${color}` }}
      />
      {compact
        ? <span>{ok ? 'live' : 'issue'}</span>
        : <span>{ok ? 'all systems operational' : 'degraded'}{agents !== null && ok ? ` · ${agents} agents online` : ''}</span>}
    </div>
  );
};
